"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      clickSubmit: false,
      baseURL: this.config.BASE_URL,
      form: {}
    };
  },
  computed: {
    siteInfo: function siteInfo() {
      return this.$store.state.user.siteInfo;
    }
  },
  mounted: function mounted() {
    console.log(this.config);
    if (this.$route.params.id > 0) this.getInfo();
  },
  methods: {
    /**
     * 获取商户信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('WxOpen/getWxPayMchInfo', {
        config_id: this.$route.params.id
      }).then(function (res) {
        res.mine_agent_id = res.agent_id;
        _this.form = _this.pick(res, ['mine_agent_id', 'app_id', 'pay_mchid', 'pay_key', 'payssl_cert', 'payssl_key', 'apiv3_key', 'serial_no', 'service_id']);
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var url = 'WxOpen/editWxPayMchInfo',
        params = JSON.parse(JSON.stringify(this.form));
      if (this.$route.params.id > 0) params.id = this.$route.params.id;
      this.clickSubmit = true;
      this.$post(url, params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        if (_this2.checkRoles(['terminal'])) {
          _this2.$router.push({
            path: '/wx/paymch'
          });
          return;
        }
        _this2.$router.push({
          path: '/wx/paymch'
        });
      }).catch(function (err) {
        _this2.clickSubmit = false;
      });
    }
  }
};